// Local i18n message definitions. IDs match what's in
// @techchange/components/src/_shared/i18n/translations/*.json, so the apps'
// existing translation bundles cover these strings automatically.

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	TC_COMPONENTS_VIDEO_LIBRARY_UPLOADER_FILE_PICKER_BUTTON_LABEL: {
		id: 'TC_COMPONENTS_VIDEO_LIBRARY_UPLOADER_FILE_PICKER_BUTTON_LABEL',
		defaultMessage: 'Choose file',
	},
	TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_ERROR: {
		id: 'TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_ERROR',
		defaultMessage: 'There was an error loading this video.',
	},
	TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_STATUS_NOT_READY_ADMIN: {
		id: 'TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_STATUS_NOT_READY_ADMIN',
		defaultMessage: 'This video is still being processed.',
	},
	TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_STATUS_NOT_READY_USER: {
		id: 'TC_COMPONENTS_VIDEO_LIBRARY_VIDEO_STATUS_NOT_READY_USER',
		defaultMessage: 'This video is not yet available.',
	},
});
